module.exports = __webpack_public_path__ + "images/ee58418e733fbd5ac41104b19adc50a3.png";